import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FavouritesContent from './components/FavouritesContent'
import GroupsContent from './components/GroupsContent'
import HistoryContent from './components/HistoryContent'
import SearchContent from './components/SearchContent'
import ExportsContent from './components/ExportsContent'

import './style.scss'

export default class StackContent extends Component {
    static propTypes = {
        activeTab: PropTypes.string.isRequired,
    }

    renderContent = (activeTab) => {
        switch (activeTab) {
            case 'search':
                return <SearchContent />
            case 'favourites':
                return <FavouritesContent />
            case 'groups':
                return <GroupsContent />
            case 'history':
                return <HistoryContent />
            case 'exports':
                return <ExportsContent />
            default:
                return null
        }
    }

    render() {
        const { activeTab } = this.props

        return <div className="entity-stack-content">{this.renderContent(activeTab)}</div>
    }
}
